<script setup>
import { deviceStore } from './../stores/deviceStore'
import  HeaderRibbon  from './HeaderRibbon.vue'
import  Terminations  from './Terminations.vue'
import  Footer  from './Footer.vue'
import  Header from './Header.vue'
import Behaviour from './Behaviour.vue'
import CommunicationRibbon from './CommunicationRibbon.vue'
import { ref } from 'vue'
import { onClickOutside } from '@vueuse/core'
import { UseDraggable } from '@vueuse/components'
import DraggableComponent from './DraggableComponent.vue'

function close () {
 /**/
}

//onClickOutside(el, close)

function getPosition(viewPort) {
  return {x : viewPort.TopLeftX , y : viewPort.TopRightY }
}

function endcall() {
  console.log("Got new end call event");
}

console.log("got store in viewport component");
//const store = deviceStore();
defineProps({
    clientID: {
      type: String,
      required: true
    },
    viewportID: {
      type: String,
      required: true
    }
})

function viewportClicked() {

}
</script>

<script>
import { deviceStore } from './../stores/deviceStore'

export default {
  components: {
      HeaderRibbon,
      Terminations,
      Footer,
      Header,
      Behaviour,
      CommunicationRibbon
  },
  data: () => ({
    showBehaviour: false,
    store: false,
    positions: {}
  }),
  created() {
    this.store = deviceStore();
  },
  mounted() {
  },
  watch: {
    'store.viewPorts': {
      async handler(newVal) {
        await this.$nextTick
        Array.isArray(newVal) && newVal.forEach((v)=>{
          let rootMenuItem = this.store.rootMenu.find(e => e.ViewPortID === v.viewportID);
          let x = rootMenuItem && (rootMenuItem.TopLeftX = v.TopLeftX) || 0;
          let y = rootMenuItem && (rootMenuItem.TopRightY = v.TopRightY) || 0;

          if(this.positions[v.viewportID] && ((this.positions[v.viewportID].x != x) || (this.positions[v.viewportID].x != y))) {
            Array.isArray(this.$refs[`comp_${v.viewportID}`]) && this.$refs[`comp_${v.viewportID}`][0] && this.$refs[`comp_${v.viewportID}`][0].setPosition && this.$refs[`comp_${v.viewportID}`][0].setPosition(x,y);
          }


          this.positions[v.viewportID] = { x, y };
        });
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    viewportClicked(menuItem) {
      //console.log('viewportClicked', 'menuItem:', menuItem);
      this.store.setActiveClient(menuItem);

    },
    deskModeToggled(viewportID, val) {
      this.store.rootMenu.find(e => e.ViewPortID === viewportID).showBehaviour = val;
    },
    getViewPortPosition(viewportID) {
      let viewport = this.store.viewPorts.find(e => e.viewportID === viewportID);
      return { x: viewport.TopLeftX, y: viewport.TopRightY};
    }
  }
}
//@click="store.setActiveClient(viewPort)"
</script>

<template>
<div name="oxygen-menu" v-for="(menuItem,index) in store.rootMenu" :key="index" class="stack-top" :id="index">
  <div name="oxygen-client" v-if="menuItem.ClientRowID" :key="menuItem.ClientRowID" class="stack-top" :class="menuItem.ClientClasses" :id="menuItem.ClientRowID">
    <div >
      <DraggableComponent  :ref="'comp_' + menuItem.ViewPortID" @click="viewportClicked(menuItem)" name="oxygen-viewport" v-if="menuItem.ViewPortID" :viewportid="menuItem.ViewPortID"  :key="menuItem.ViewPortID" :id="menuItem.ViewPortID"

                            :style="store.getViewPortStyle(menuItem.ViewPortID)"
                           :position="positions[menuItem.ViewPortID] || {x: 0, y: 0}">
            <template #fullheader>
            </template>
            <template #header>
                <Header v-on:desk-mode-toggled="deskModeToggled" name="oxygen-header" v-if="store.isLanding == false"  :ClientID="menuItem.ClientRowID" :viewportID="menuItem.ViewPortID" :style="store.getHeaderStyle(menuItem.ViewPortID)"></Header>
            </template>
            <template #communicationRibbon>
                <CommunicationRibbon  id="oxygen-communicationribbon-part" class="behaviourcontents" :ClientID="menuItem.ClientRowID" :viewportID="menuItem.ViewPortID" :Thread="menuItem.LeftID" :Subject="menuItem.RightID" style="display:none;"></CommunicationRibbon>
            </template> 
            <template #behaviour>
                <Behaviour v-show="menuItem.showBehaviour" v-if="store.behaviours[menuItem.LeftID+menuItem.RightID] && store.behaviours[menuItem.LeftID+menuItem.RightID].Rules && store.behaviours[menuItem.LeftID+menuItem.RightID].Rules.length > 0" id="oxygen-behaviour-part" class="behaviourcontents" :ClientID="menuItem.ClientRowID" :viewportID="menuItem.ViewPortID" :Thread="menuItem.LeftID" :Subject="menuItem.RightID" ></Behaviour>
            </template>
            <template v-if="menuItem.TerminationID" :key="menuItem.TerminationID"  #body>
                  <div name="oxygen-termination"  :class="menuItem.TerminationClasses" :id="menuItem.TerminationID"   style="width:100%;overflow-x:hidden;overflow-y:auto;"></div>
            </template>
        <template #footer>
          <Footer  v-if="store.isLanding == false"  :ClientID="menuItem.ClientRowID" :viewportID="menuItem.ViewPortID"></Footer>
        </template>
      </DraggableComponent>
    </div>
  </div>
</div>
</template>

<style scoped>
.viewer-role-enabled {
  /*pointer-events: none;*/
}
.open-hidden {
  display: none;
}
</style>
